import '../Model/Query';
export class WitnessGenderService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOneByDiligenceNumber(diligenceNumber) {
        if (diligenceNumber) {
            const response = await this.apiService.get('witnessgender/' + diligenceNumber);
            if (!response.ok) {
                throw new Error(`Error al obtener el testigo de violencia de genero.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener diligenceNumber.`);
        }
    }
    async saveWitness(diligence) {
        if (diligence) {
            const response = await this.apiService.post('witnessgender', diligence);
            if (!response.ok) {
                throw new Error(`Error al guardar el testigo.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener witness.`);
        }
    }
    async deleteWitness(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('witnessgender/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el testigo.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el testigo.`);
        }
    }
}
